/* eslint-disable */
import {
  Button,
  Checkbox,
  Flex,
  message,
  Modal,
  Popover,
  Radio,
  Space,
  Dropdown,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  CaretDownOutlined,
  EditOutlined,
  OneToOneOutlined,
  SyncOutlined,
  SolutionOutlined,
  MenuOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import AddModal from "./component/AddModal";
import ResetModal from "./component/ResetModal";
export default function TypeJob() {
  const addModalRef = useRef(null);
  const EditModalRef = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableList, setTableList] = useState([]);
  const childRef = useRef();
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [tableHead, setTableHead] = useState({
    status: "completed",
    completedRemark: null,
    completedByName: null,
    remark: null,
    assignedToName: null,
    propUnit: null,
    unitStatus: null,
    propType: null,
    units: null,
    unitStatus: null,
    sCompletedTime: null,
    eCompletedTime: null,
    city: null,
  });
  const showModalAdd = () => {
    addModalRef.current?.setModelAdd();
  };
  const showModalThree = () => {
    console.log("==========刷新按钮============");
    if (
      childRef.current &&
      typeof childRef.current.clearInputs === "function"
    ) {
      childRef.current.clearInputs();
      childRef.current.newListFun();
    }
  };
  const handleMenuClick = async (e, record) => {
    console.log(record);
    if (e.key === "reset") {
      EditModalRef.current?.open(record);
    }

    if (e.key === "delete") {
      Modal.confirm({
        title: "Complete Request",
        icon: <ExclamationCircleOutlined />,
        content: <span>Are you sure to delete this job type?</span>,
        okText: "Sure",
        cancelText: "Cancel",
        async onOk() {
          setLoading(true);
          try {
            const params = { id: record.id };
            const response = await http.get(api.getjobtypedelete, { params });
            if (response.code === "1") {
              message.success("Successfully deleted.");
              fetchData(pagination.current, pagination.pageSize);
            } else {
              message.error(response?.msg || "Delete failed.");
            }
          } catch (error) {
            message.error("An error occurred. Please try again.");
          } finally {
            setLoading(false);
          }
        },

        onCancel() {
          form.resetFields();
        },
        style: {
          top: "40%",
        },
      });
    }
  };

  // table
  const initTableHead = {
    role: null,
    module: null,
    firstName: null,
    dateTimeRequest: null,
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      align: "center",
      width: 80,
      render: (text, record) =>
        (commonFn.btnAuthorityFlag("ModifyJobType") ||
          commonFn.btnAuthorityFlag("DeleteJobType")) && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("ModifyJobType") && {
                  key: "reset",
                  icon: (
                    <EditOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Modify Job Type</div>,
                },
                commonFn.btnAuthorityFlag("DeleteJobType") && {
                  key: "delete",
                  icon: (
                    <SolutionOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Delete Job Type</div>,
                },
              ],
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        ),
    },
    {
      title: "Type Name",
      dataIndex: "name",
      key: "name",
      width: 300,
      align: "center",
      render: (text, record) => {
        const style = {};
        if (record.level === 1) {
          style.fontWeight = "bold";
        }
        return <div style={style}>{text}</div>;
      },
    },

    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      align: "center",
      hidden: false,
      width: 100,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      align: "center",
      width: 200,
    },
    {
      title: "Gl Monthly Worker",
      dataIndex: "glMonthlyWorkerStr",
      key: "glMonthlyWorkerStr",
      align: "center",
    },
    {
      title: "Gl Contractor",
      dataIndex: "glContractorStr",
      key: "glContractorStr",
      align: "center",
    },
    {
      title: "Monthly Worker V",
      dataIndex: "monthlyWorkerVStr",
      key: "monthlyWorkerVStr",
      align: "center",
    },
    {
      title: "Contractor V",
      dataIndex: "contractorVStr",
      key: "contractorVStr",
      align: "center",
    },
    {
      title: "Create By",
      dataIndex: "createByName",
      key: "createByName",
      align: "center",
    },
    {
      title: "Create Time",
      dataIndex: "createTime",
      key: "createTime",
      align: "center",
      width: 200,
      render: (text, record, index) =>
        text ? moment(text).format("MM/DD/YYYY HH:mm") : " ",
    },
    {
      title: "Update By",
      dataIndex: "updateByName",
      key: "updateByName",
      align: "center",
      width: 100,
    },
    {
      title: "Update Time",
      dataIndex: "updateTime",
      key: "updateTime",
      align: "center",
      render: (text, record, index) =>
        text ? moment(text).format("MM/DD/YYYY HH:mm") : " ",
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 处理选项变化
  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);

    const response = await http.get(api.getjobTypeshow);
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data || []).map((item, index) => ({
      ...item,
      key: item.id,
    }));
    setTableList(list);

    setTableLoading(false);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          {(commonFn.btnAuthorityFlag("Add") && (
            <Space size="large">
              <Button className="btnNew" onClick={showModalAdd}>
                <PlusOutlined />
                New
              </Button>
            </Space>
          )) ||
            null}
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>
      {/* <MainTable ref={childRef} deleteNum={deleteNum} ></MainTable> */}
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        tableCss="maintenanceTable"
        rowKey="id"
      />

      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn();
        }}
      />
      <ResetModal
        ref={EditModalRef}
        onSuccess={() => {
          getTableListFn();
        }}
      />
    </div>
  );
}
